import { createContext, useContext, useState, useEffect } from 'react';

const PlanContext = createContext();

export const usePlan = () => useContext(PlanContext);

export const PlanProvider = ({ children }) => {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(() => {
    const stored = sessionStorage.getItem('selectedPlan');
    return stored ? JSON.parse(stored) : null;
  });

  // ⏬ Fetch live plans from backend
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
        const res = await fetch(`${baseUrl}/api/partner/plans`);
        if (!res.ok) throw new Error(`Failed to fetch plans (${res.status})`);
        const data = await res.json();
        setPlans(data);
      } catch (err) {
        console.error('❌ PlanContext: Could not load plans', err);
      }
    };
  
    fetchPlans();
  }, []);
  

  // 💾 Persist selected plan to session storage
  useEffect(() => {
    if (selectedPlan) {
      sessionStorage.setItem('selectedPlan', JSON.stringify(selectedPlan));
    }
  }, [selectedPlan]);

  return (
    <PlanContext.Provider value={{ plans, selectedPlan, setSelectedPlan }}>
      {children}
    </PlanContext.Provider>
  );
};
